import { useConsultationContext } from '../../context/ConsultationContext';
import { format } from 'date-fns';
import moment from 'moment';
import styles from './ConsultationParentComponent.module.scss';
import { useTranslation } from '../../hooks/useTranslations';
import { fetchServicesTranslations, selectServicesTranslations } from '../../store/slices/salesOrders';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { buildTranslatedServicesMap, getTranslatedServicesName } from '../../utils/miscUtils';
import { useEffect, useMemo } from 'react';

export default function MenuItem({ menuItem }: { menuItem: any }) {
  const { translations } = useTranslation();
  const {
    addTab,
    selectedSalesOrder: { customer_person, sales_order_appointment, service, sales_order },
  } = useConsultationContext();

  const renderComponente = {
    0: <CustomerInformation customer_person={customer_person} menuItem={menuItem} />,
    1: (
      <AppointmentDetails
        data={{ sales_order: sales_order, ...sales_order_appointment }}
        service={service}
        menuItem={menuItem}
      />
    ),
  };

  return (
    <div className={styles.menuItem} onClick={() => addTab(menuItem)}>
      <div className={styles.wrapper}>
        <p className={styles.menuItemText}>{translations(menuItem.text)}</p>
        {!Boolean(renderComponente[menuItem?.value as keyof typeof renderComponente]) && (
          <i className={styles.menuItemIcon} />
        )}
      </div>
      {renderComponente[menuItem?.value as keyof typeof renderComponente]}
    </div>
  );
}

const CustomerInformation = ({ customer_person, menuItem }: any) => {
  const { translations } = useTranslation();

  return (
    <div className={styles.menuBody}>
      <div className={styles.infoWrap}>
        <div className={styles.label}>{translations('full.name')} </div>
        <div
          className={styles.value}
        >{`${customer_person?.person_firstname} ${customer_person?.person_lastname}`}</div>
      </div>
      {customer_person?.person_email && (
        <div className={styles.infoWrap}>
          <div className={styles.label}>{translations('email')}</div>
          <div className={styles.value}>{`${customer_person?.person_email}`}</div>
        </div>
      )}
      <div className={styles.infoWrap}>
        <div className={styles.label}>{translations('date.of.birth')}</div>
        <div className={styles.value}>{`${format(
          new Date(customer_person?.person_birthdate),
          'dd.MM.yyyy'
        )}`}</div>
      </div>
      <div className={styles.seeMore}>
      {translations('see.more')}
        <i className={styles.menuItemIcon} />
      </div>
    </div>
  );
};

const AppointmentDetails = ({ data, service, menuItem }: any) => {
  const { translations } = useTranslation();
    const dispatch = useAppDispatch();
  const lang = localStorage.getItem('lang') || 'en';
    const servicesTranslations = useAppSelector(selectServicesTranslations);

      useEffect(() => {
        dispatch(fetchServicesTranslations());
      }, [dispatch]);

  const translatedServicesMap = useMemo(
  () => buildTranslatedServicesMap(servicesTranslations, lang),
  [servicesTranslations, lang]
);

  return (
    <div className={styles.menuBody}>
      <div className={styles.infoWrap}>
        <div className={styles.label}>{translations('appointment.id')}</div>
        {data?.sales_order_appointment_id && (
          <div className={styles.value}>{`${data?.sales_order.sales_order_id}`}</div>
        )}
      </div>
      <div className={styles.infoWrap}>
        <div className={styles.label}>Service</div>
        <div className={styles.value}>{getTranslatedServicesName(
                          service?.service_id,
                         translatedServicesMap
                        )}</div>
      </div>
      <div className={styles.infoWrap}>
        <div className={styles.label}>{translations('date_and_time')}</div>
        {data.start ? (
          <div className={styles.value}>{`${moment(data.start)
            .locale(lang)
            .format('DD.MM.yyyy | HH:mm')}`}</div>
        ) : (
          <div className={styles.value}>{translations('walkin_appointment')}</div>
        )}
      </div>
      <div className={styles.infoWrap}>
        <div className={styles.label}>{translations('start')}</div>
        <div className={styles.value}></div>
      </div>
      <div className={styles.seeMore}>
      {translations('see.more')}
              <i className={styles.menuItemIcon} />
      </div>
    </div>
  );
};
